import { transparentPixel } from "@utils/string";
import Image from "next/image";
import { FC } from "react";

import { Media } from "@/types";

interface CardImageSimpleProps {
  image: Media;
  aspectRatio: "3:4" | "4:3";
}

const CardImageSimple: FC<CardImageSimpleProps> = ({ image, aspectRatio }) => {
  // TODO probably update the fixed width/height
  return (
    <div className={`h-CardGallery md:h-CardGalleryDesktop ${aspectRatio === "3:4" ? "aspect-3-4" : "aspect-4-3"}`}>
      <Image
        className="object-cover w-full h-full rounded-md"
        src={image.url || transparentPixel}
        alt={image.description || image.title}
        width={`${aspectRatio === "3:4" ? "343" : "457"}`}
        height={`${aspectRatio === "3:4" ? "457" : "343"}`}
      />
    </div>
  );
};
export default CardImageSimple;
